export const buttonContainerPropsStyle = { height: 30, borderRadius: 8 }
export const buttonTextPropsStyle = { fontSize: 18 }
